import Component from "./Content";
import Avatar from "./components/Avatar/ContentAvatar";
import Badge from "./components/Badge/ContentBadge";
import Dot from "./components/Dot/ContentDot";
import Icon from "./components/Icon/ContentIcon";
import Link from "./components/Link/ContentLink";
import Picture from "./components/Picture/ContentPicture";
import Tag from "./components/Tag/ContentTag";
import Text from "./components/Text/ContentText";

interface IContentExtensions {
    Avatar: typeof Avatar;
    Badge: typeof Badge;
    Dot: typeof Dot;
    Icon: typeof Icon;
    Picture: typeof Picture;
    Text: typeof Text;
    Link: typeof Link;
    Tag: typeof Tag;
}

export const Content: typeof Component & IContentExtensions = Object.assign(
    Component,
    {
        Avatar,
        Badge,
        Dot,
        Icon,
        Picture,
        Text,
        Link,
        Tag,
    },
);

export type { ContentProps } from "./Content";
export type {
    ContentSize,
    ContentBaseAlignments,
    ContentAlignmentX,
    ContentAlignmentY,
    ContentView,
    ContentTextAndIconView,
} from "./types";
